import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createUserOnboarding } from '@flecto/api/shared'
import type { CoreUserOnboardingPayload } from '@flecto/types'

export function useMutationSetupOnboarding() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationSetupUserOnboarding'],
    mutationFn: async (payload: CoreUserOnboardingPayload) => {
      return await createUserOnboarding({ onboarding: payload })
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['QueryGetUserLogged'])
    },
  })
}
